import { ModelFactory } from "../../ModelFactory";

export class Task {
  constructor(
    public readonly id: string,
    public readonly type: string,
    public readonly description: string | null,
    public readonly status: string,
    public readonly input: object,
    public readonly output: object | null,
    public readonly created: Date,
    public readonly updated: Date,
    public readonly started: Date | null,
    public readonly finished: Date | null,
  ) {
  }
}

class TaskFactory extends ModelFactory<Task> {
  protected fromJson(json: any): Task {
    return new Task(
      json['id'],
      json['type'],
      json['description'] ?? null,
      json['status'],
      json['input'],
      json['output'] ?? null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['started_at'] ? new Date(json['started_at']) : null,
      json['finished_at'] ? new Date(json['finished_at']) : null,
    );
  }
}
export const taskFactory = new TaskFactory();
